"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generatePreview = generatePreview;

var _parametersParser = require("./parametersParser");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Descriptor containing all objects to display in the given order
var DISPLAY_INFO = [{
  path: "Background.Image",
  type: "always"
}, {
  path: "Background.ImageIndex",
  type: "always"
}, // TODO: support flag drawOrder DisplayMinutesFirst
{
  path: "Time.Hours",
  type: "twoDigits",
  statusName: "hours"
}, {
  path: "Time.Minutes",
  type: "twoDigits",
  statusName: "minutes"
}, {
  path: "Time.Seconds",
  type: "twoDigits",
  statusName: "seconds"
}, {
  path: "Time.DelimiterImage",
  type: "always"
}, {
  path: "Time.TimeDelimiterImage",
  type: "always"
}, {
  path: "TimeNew.Hours",
  type: "number",
  statusName: "hours",
  padZeros: 2
}, {
  path: "TimeNew.MinutesAndSeconds.Minutes",
  type: "number",
  statusName: "minutes",
  padZeros: 2
}, {
  path: "TimeNew.MinutesAndSeconds.Seconds",
  type: "number",
  statusName: "seconds",
  padZeros: 2
}, {
  path: "Activity.Steps",
  type: "numberWithExtra",
  statusName: "steps"
}, {
  path: "Activity.Calories",
  type: "numberWithExtra",
  statusName: "calories"
}, {
  path: "Activity.Pulse",
  type: "numberWithExtra",
  statusName: "pulse"
}, {
  path: "Activity.Distance",
  type: "numberWithExtra",
  statusName: "distance"
}, {
  path: "Activity.PAI",
  type: "numberWithExtra",
  statusName: "pai"
}, {
  path: "Date.MonthAndDayAndYear.Separate.Month",
  type: "number",
  statusName: "month",
  padZeros: 2
}, {
  path: "Date.MonthAndDayAndYear.Separate.Months{lang}",
  type: "imageFromRange",
  statusName: "month"
}, {
  path: "Date.MonthAndDayAndYear.Separate.Day",
  type: "number",
  statusName: "day",
  padZeros: 2
}, {
  path: "Date.MonthAndDayAndYear.SeparateNew.Month",
  type: "number",
  statusName: "month",
  padZeros: 2
}, {
  path: "Date.MonthAndDayAndYear.SeparateNew.Day",
  type: "number",
  statusName: "day",
  padZeros: 2
}, {
  path: "Date.MonthAndDayAndYear.OneLine",
  type: "numberWithDelimiter",
  statusName: "month/day",
  padZeros: 2
}, {
  path: "Date.MonthAndDayAndYear.OneLineWithYear",
  type: "numberWithDelimiter",
  statusName: "year/month/day",
  padZeros: 2
}, {
  path: "Date.DayAmPm",
  type: "ampm",
  statusName: "pm"
}, {
  path: "Date.{lang}WeekDays",
  type: "imageFromRange",
  statusName: "weekday"
}, {
  path: "Date.WeekDays",
  type: "imageFromRange",
  statusName: "weekday"
}, {
  path: "Weather.Icon.CustomIcon",
  type: "imageFromRange",
  statusName: "weather"
}, {
  path: "Weather.Temperature.Current",
  type: "numberWithExtra",
  statusName: "currentTemperature"
}, {
  path: "Weather.Temperature.Today.Separate.Day",
  type: "numberWithExtra",
  statusName: "dayTemperature"
}, {
  path: "Weather.Temperature.Today.Separate.Night",
  type: "numberWithExtra",
  statusName: "nightTemperature"
}, {
  path: "Weather.Temperature.Today.OneLine",
  type: "numberWithDelimiter",
  statusName: "dayTemperature/nightTemperature"
}, {
  path: "Weather.Humidity",
  type: "numberWithExtra",
  statusName: "humidity"
}, {
  path: "Weather.Wind",
  type: "numberWithExtra",
  statusName: "wind"
}, // TODO: chinese uv index display
{
  path: "Weather.UVIndex.UV",
  type: "numberWithExtra",
  statusName: "uvi"
}, {
  path: "StepsProgress.LineScale",
  type: "lineScale",
  statusName: "stepsPercent"
}, {
  path: "StepsProgress.Linear",
  type: "linear",
  statusName: "stepsPercent"
}, {
  path: "Status.DoNotDisturb",
  type: "onoff",
  statusName: "doNotDisturb"
}, {
  path: "Status.Lock",
  type: "onoff",
  statusName: "lock"
}, {
  path: "Status.Bluetooth",
  type: "onoff",
  statusName: "bluetooth"
}, {
  path: "Status.Battery.Number",
  type: "number",
  statusName: "batteryPercent"
}, {
  path: "Status.Battery.BatteryIcon",
  type: "lineScale",
  statusName: "batteryPercent"
}, {
  path: "Battery.BatteryText",
  type: "numberWithExtra",
  statusName: "batteryPercent"
}, {
  path: "Battery.BatteryIcon",
  type: "lineScale",
  statusName: "batteryPercent"
}, {
  path: "Battery.Linear",
  type: "linear",
  statusName: "batteryPercent"
}, {
  path: "Other.Animation",
  type: "animation",
  statusName: "animationTime"
}, {
  path: "HeartProgress.LineScale",
  type: "lineScale",
  statusName: "heartPercent"
}, {
  path: "HeartProgress.Linear",
  type: "linear",
  statusName: "heartPercent"
}, {
  path: "CaloriesProgress.LineScale",
  type: "lineScale",
  statusName: "caloriesPercent"
}, {
  path: "CaloriesProgress.Linear",
  type: "linear",
  statusName: "caloriesPercent"
}, {
  path: "WeekDaysIcons",
  type: "weekday",
  statusName: "weekday"
}, {
  path: "Alarm",
  type: "numberWithDelimiter",
  statusName: "alarmHours/alarmMinutes",
  padZeros: 2
}, {
  path: "Alarm",
  type: "onoff",
  statusName: "alarmOnOff"
}, // TODO: Status2 is supposed to be stacked
{
  path: "Status2.DoNotDisturb",
  type: "onoff",
  statusName: "doNotDisturb"
}, {
  path: "Status2.Lock",
  type: "onoff",
  statusName: "lock"
}, {
  path: "Status2.Bluetooth",
  type: "onoff",
  statusName: "bluetooth"
}, {
  path: "AnalogDialFace.Hours",
  type: "clockHand",
  statusName: "hours"
}, {
  path: "AnalogDialFace.Minutes",
  type: "clockHand",
  statusName: "minutes"
}, {
  path: "AnalogDialFace.Seconds",
  type: "clockHand",
  statusName: "seconds"
}];
/**
 * Return the ids and positions of the images to display to generate a preview of the given status
 * @param {object} parameters Parameters of the watchface
 * @param {{width: number, height: number}[]} images Resources images of the watchface (actual data is not needed, only size is enough)
 * @param {object} status object containing the status to display
 * @param {object} watchModelDescriptor descriptor of the watch model
 * @returns {{imageId: number, position: {x: number, y: number}}[]}
 */

function generatePreview(parameters, images, status, watchModelDescriptor) {
  var result = [];

  var _iterator = _createForOfIteratorHelper(DISPLAY_INFO),
      _step;

  try {
    var _loop = function _loop() {
      var _status$locale;

      var info = _step.value;
      var lang = (_status$locale = status.locale) === null || _status$locale === void 0 ? void 0 : _status$locale.lang; // check path exists in parameter

      var parameter = getPath(parameters, info.path, lang);

      if (!parameter) {
        // not found in this watchface, skip
        return "continue";
      }

      var value = void 0,
          values = void 0;

      if (info.statusName) {
        values = info.statusName.split("/").map(function (e) {
          return status[e];
        });
        value = values[0];
      }

      switch (info.type) {
        case "always":
          if (typeof parameter === "number") {
            result.push({
              imageId: parameter,
              position: {
                x: 0,
                y: 0
              }
            });
          } else {
            displaySingleImage(result, parameter);
          }

          break;

        case "twoDigits":
          //format number as string with leading zeros
          var chars = String(value).padStart(2, '0');
          displayImageFromRange(result, parameter.Tens, +chars[0]);
          displayImageFromRange(result, parameter.Ones, +chars[1]);
          break;

        case "number":
          displayText(result, images, convertNumberToImageIds(Math.round(value), parameter, info.padZeros), parameter);
          break;

        case "imageFromRange":
          displayImageFromRange(result, parameter, value - 1);
          break;

        case "numberWithExtra":
          if (parameter.SpacingX !== undefined) {
            parameter = {
              Number: _objectSpread({}, parameter)
            }; // Actually just a number

            if (info.path.startsWith("Weather.Temperature.") && parameters.Weather.Temperature.Symbols) {
              parameter = _objectSpread(_objectSpread({}, parameter), parameters.Weather.Temperature.Symbols);
            }
          }

          var textImageIds;

          if (value) {
            textImageIds = convertNumberToImageIds(value, parameter.Number, info.padZeros, parameter.DecimalPointImageIndex, parameter.MinusImageIndex);
          } else if (parameter.NoDataImageIndex) {
            textImageIds = [parameter.NoDataImageIndex];
          } else {
            // No value, and no NoDataImageIndex, nothing to display here
            break;
          }

          if (parameter.PrefixImageIndex) {
            textImageIds.unshift(parameter.PrefixImageIndex);
          }

          if (parameter.SuffixImageIndex) {
            textImageIds.push(parameter.SuffixImageIndex);
          }

          if (parameter["SuffixImageIndex".concat(lang)]) {
            textImageIds.push(parameter["SuffixImageIndex".concat(lang)]);
          }

          if (parameter.KmSuffixImageIndex && !status.locale.imperial) {
            textImageIds.push(parameter.KmSuffixImageIndex);
          }

          if (parameter.MilesSuffixImageIndex && status.locale.imperial) {
            textImageIds.push(parameter.MilesSuffixImageIndex);
          }

          displayText(result, images, textImageIds, parameter.Number); // If there is a positionned suffix image

          if (parameter.ImagePosSuffix) {
            displaySingleImage(result, parameter.ImagePosSuffix);
          }

          if (parameter["ImagePosSuffix".concat(lang)]) {
            displaySingleImage(result, parameter["ImagePosSuffix".concat(lang)]);
          }

          break;

        case "numberWithDelimiter":
          {
            if (!parameter.Number) {
              break;
            }

            var _textImageIds = values.map(function (v) {
              return convertNumberToImageIds(v, parameter.Number, info.padZeros, null, parameter.MinusImageIndex);
            }).reduce(function (a, b) {
              if (parameter.SuffixImageIndex && parameter.AppendSuffixToAll) {
                a.push(parameter.SuffixImageIndex);
              }

              return [].concat(_toConsumableArray(a), [parameter.DelimiterImageIndex], _toConsumableArray(b));
            });

            if (parameter.SuffixImageIndex) {
              _textImageIds.push(parameter.SuffixImageIndex);
            }

            displayText(result, images, _textImageIds, parameter.Number);
            break;
          }

        case "ampm":
          if (!status.locale.time24h) {
            var ampm = value ? "PM" : "AM";
            var imageId = parameter["ImageIndex".concat(ampm).concat(lang)];
            var x = parameter["X_".concat(lang)] || parameter.X;
            var y = parameter["Y_".concat(lang)] || parameter.Y;

            if (parameter.AMPosition && !value) {
              x = parameter.AMPosition.X;
              y = parameter.AMPosition.Y;
            }

            if (parameter.PMPosition && value) {
              x = parameter.PMPosition.X;
              y = parameter.PMPosition.Y;
            }

            displayImage(result, imageId, x, y);
          }

          break;

        case "onoff":
          if (parameter.OnImageIndex !== undefined && value) {
            displayImage(result, parameter.OnImageIndex, parameter.Coordinates.X, parameter.Coordinates.Y);
          }

          if (parameter.OffImageIndex !== undefined && !value) {
            displayImage(result, parameter.OffImageIndex, parameter.Coordinates.X, parameter.Coordinates.Y);
          }

          if (parameter.OnImage !== undefined && value) {
            displaySingleImage(result, parameter.OnImage);
          }

          if (parameter.OffImage !== undefined && !value) {
            displaySingleImage(result, parameter.OffImage);
          }

          break;

        case "lineScale":
          displayImageFromRange(result, parameter, Math.round(value / 100 * (parameter.ImagesCount - 1)));
          break;

        case "linear":
          var progress = Math.round(value / 100 * (parameter.Segments.length - 1));

          for (var i = 0; i <= progress; i++) {
            var pos = parameter.Segments[i];
            displayImage(result, parameter.StartImageIndex + i, pos.X, pos.Y);
          }

          break;

        case "weekday":
          var weekDayString = {
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday",
            "7": "Sunday"
          }[value];
          displaySingleImage(result, parameter[weekDayString]);
          break;

        case "animation":
          var _iterator2 = _createForOfIteratorHelper(Array.isArray(parameter) ? parameter : [parameter]),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var animation = _step2.value;
              // Real watch can't display faster than about 80ms interval
              var speed = Math.max(animation.Speed, 80);
              var currentFrame = Math.round(value / speed);
              var currentFrameLooped = currentFrame % animation.AnimationImages.ImagesCount; // display only if repeat count is not exceeded

              if (animation.RepeatCount === 0 || currentFrame < animation.RepeatCount * animation.AnimationImages.ImagesCount) displayImageFromRange(result, animation.AnimationImages, currentFrameLooped);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          break;

        case "clockHand":
          // compute angle
          var totalValue = info.statusName == "hours" ? 12 : 60;
          var angle = 2 * Math.PI * value / totalValue - Math.PI / 2; // create a canvas to draw and transform the vector shape

          var canvas = document.createElement('canvas');
          canvas.width = watchModelDescriptor.screen.width;
          canvas.height = watchModelDescriptor.screen.height;
          var ctx = canvas.getContext("2d"); // translate and rotate to position

          ctx.translate(parameter.Center.X, parameter.Center.Y);
          ctx.rotate(angle); // draw the shape

          var coordinates = parameter.Shape;
          ctx.fillStyle = parameter.Color.replace("0x", "#");
          ctx.strokeStyle = ctx.fillStyle;
          ctx.beginPath();
          ctx.moveTo(coordinates[0].X, coordinates[0].Y);
          coordinates.slice(1).forEach(function (coord) {
            return ctx.lineTo(coord.X, coord.Y);
          });
          ctx.closePath();

          if (parameter.OnlyBorder) {
            ctx.stroke();
          } else {
            ctx.fill();
          }

          result.push({
            canvas: canvas,
            position: {
              x: 0,
              y: 0
            }
          });

          if (parameter.CenterImage) {
            displaySingleImage(result, parameter.CenterImage);
          }

          break;
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    } // Check all imagesIds are valids

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  for (var _i = 0, _result = result; _i < _result.length; _i++) {
    var imageInfo = _result[_i];

    if (imageInfo.canvas) {
      continue;
    }

    if (typeof imageInfo.imageId !== 'number') {
      throw new Error("Invalid image Id");
    }

    if (imageInfo.imageId >= images.length) {
      throw new Error("Image Id out of range");
    }
  }

  return result;
}
/**
 * Return the value at `path` in object if it exists, undefined otherwise
 * @param {object} object 
 * @param {string} path 
 * @param {string} lang Languages to use (EN, CN, CN2)
 */


function getPath(object, path, lang) {
  var result = object;

  var _iterator3 = _createForOfIteratorHelper(path.replace("{lang}", lang).split(".")),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      result = result[key];

      if (result === undefined) {
        break;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return result;
}

function displayImage(result, imageId, x, y) {
  result.push({
    imageId: imageId,
    position: {
      x: x,
      y: y
    }
  });
}

function displaySingleImage(result, singleImageParameter) {
  result.push({
    imageId: singleImageParameter.ImageIndex,
    position: {
      x: singleImageParameter.X,
      y: singleImageParameter.Y
    }
  });
}

function displayImageFromRange(result, imageRangeParameter, value) {
  result.push({
    imageId: imageRangeParameter.ImageIndex + value,
    position: {
      x: imageRangeParameter.X,
      y: imageRangeParameter.Y
    }
  });
}

function displayText(result, images, elementImageIds, style) {
  // convert aligment to flag value
  var alignment = (0, _parametersParser.parseParameterValue)(style.Alignment, "alignment"); // compute width of text to display

  var textWidth = elementImageIds.map(function (imgId) {
    return images[imgId].width;
  }).reduce(function (a, b) {
    return a + b + style.SpacingX;
  }); // compute coordinates of the left of the first character

  var x = computePositionWithAligment(style.TopLeftX, style.BottomRightX, textWidth, alignment); // Add all characters

  var _iterator4 = _createForOfIteratorHelper(elementImageIds.entries()),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _slicedToArray(_step4.value, 2),
          i = _step4$value[0],
          elementImageId = _step4$value[1];

      var image = images[elementImageId];
      result.push({
        imageId: elementImageId,
        position: {
          x: x,
          y: computePositionWithAligment(style.TopLeftY, style.BottomRightY, image.height, alignment >> 3) + i * (style.SpacingY || 0)
        }
      });
      x += image.width + style.SpacingX;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
/**
 * Compute position of element withing the given bounds for the given aligment
 * @param {number} lowerBound 
 * @param {number} upperBound 
 * @param {number} elementSize
 * @param {number} alignment //flag containing the aligment 2: upper bound, 4: lower bound, 8: centered
 * @returns {{x: number, y: number}}
 */


function computePositionWithAligment(lowerBound, upperBound, elementSize, alignment) {
  var result;

  if (alignment & 0x02) {
    // lower bound align
    result = lowerBound;
  } else if (alignment & 0x04) {
    // upper bound align
    result = upperBound - elementSize;
  } else
    /*if (alignment & 0x08)*/
    {
      // center align (default)
      result = Math.round((lowerBound + upperBound) / 2 - elementSize / 2);
    } // don't allow to go lower than the lower bound


  return Math.max(result, lowerBound);
}

function convertNumberToImageIds(value, imageRange) {
  var padZeros = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var decimalPointImageIndex = arguments.length > 3 ? arguments[3] : undefined;
  var minusImageIndex = arguments.length > 4 ? arguments[4] : undefined;
  // convert number to string
  var digitsString = String(value).padStart(padZeros, "0");
  return _toConsumableArray(digitsString).map(function (digit) {
    if (digit === '.') {
      return decimalPointImageIndex;
    }

    if (digit === '-') {
      return minusImageIndex;
    }

    return imageRange.ImageIndex + +digit;
  });
}